import { render } from "./promoItem.vue?vue&type=template&id=93d2d6f8"
import script from "./promoItem.vue?vue&type=script&lang=js"
export * from "./promoItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__